import salonSubscription from 'utils/salons/salonSubscription.util';

const salonSubscriptionWithSplit = (hasBilling, pricingPlan, essentialSplitPayments) => {
  if (essentialSplitPayments) return false;
  return salonSubscription(hasBilling, pricingPlan);
};

export default salonSubscriptionWithSplit;
